(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('BackdoorService', BackdoorService);

    BackdoorService.$inject = ['$uibModal'];

    function BackdoorService ($uibModal) {

        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/backdoor/backdoor.html',
                controller: 'BackdoorController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
